import type { IFuseOptions } from "fuse.js";

// Configuration for simple name-based search
export const nameFuseConfig: IFuseOptions<{ name: string }> = {
  includeScore: false,
  isCaseSensitive: false,
  keys: ["name"],
  threshold: 0.3,
};
